import React, { useState } from "react";
import './index.css';
import {numArray, smallArr, capArr, spArr, mixArr, spMix} from "./Data";
import CopyToClipboard from "react-copy-to-clipboard";
import 'animate.css';

function Password(){

    const [pass, changePass] = useState("");
    const [msg, displayMsg] = useState(false);
    const [error, setError] = useState("")
    const currDate = new Date().getFullYear();

    function changePassword(){
        const numRandom = Math.floor(Math.random() * numArray.length);
        const smallRandom = Math.floor(Math.random() * smallArr.length);
        const capRandom = Math.floor(Math.random() * capArr.length);
        const spRandom = Math.floor(Math.random() * spArr.length);
        const mixRandom = Math.floor(Math.random() * mixArr.length);
        const spMRandom = Math.floor(Math.random() * spMix.length);
        changePass(numArray[numRandom]+smallArr[smallRandom]+capArr[capRandom]+spArr[spRandom]+mixArr[mixRandom]+numArray[numRandom]+capArr[capRandom]+spMix[spMRandom]);
        setError("");
    }
    
    function show(){
        if(pass === ""){
            setError("**Click on generate first");
        }
        else{
            displayMsg(true);
        }
    }

    return(
        <>
        <div className="cover">
        <div style={{textAlign: 'center'}} className="animate__animated animate__fadeIn">
            <h2>Free Password Generator</h2>
            </div>
            <div style={{textAlign: 'center'}} className="animate__animated animate__fadeIn">
            <p>You don't have to remember passwords anymore</p>
            </div>
            <p className="animate__animated animate__fadeIn">Just Copy and Use</p>
            <div className="input animate__animated animate__fadeIn">
            <input type="text" placeholder="Click below to generate" value={pass}/>
            </div>
            <p style={{fontSize: '1.5rem', marginTop: '1rem', fontWeight: 'bold'}}>{error}</p>
            <div className="btn animate__animated animate__fadeIn">
            <button onClick={changePassword} className="g-btn">Generate Password</button>

            <CopyToClipboard text={pass} onCopy={show}>
            <button className="c-btn">Copy</button>
            </CopyToClipboard>
            </div>
            {msg ? <h3>Copied!</h3> : null}

            </div>
            <div className="footer">
                &copy; {currDate} Dev Rastogi
            </div>
        </>
    )
}

export default Password;